// extracted by mini-css-extract-plugin
export var content = "ReleaseDetails-module--content--R1I4M";
export var description = "ReleaseDetails-module--description--H4q1g";
export var heading = "ReleaseDetails-module--heading--JOuT4";
export var image = "ReleaseDetails-module--image--MPSA9";
export var subheading = "ReleaseDetails-module--subheading--xqzmT";
export var text = "ReleaseDetails-module--text--lx+Pw";
export var track = "ReleaseDetails-module--track--avzbz";
export var tracks = "ReleaseDetails-module--tracks--5LfMb";
export var wrapper = "ReleaseDetails-module--wrapper--fCJpc";